<div
  class="context-menu-wrapper"
  uib-dropdown
  dropdown-append-to-body
  is-open="visible"
>
  <ul
    class="dropdown-menu context-menu"
    uib-dropdown-menu
    id="{{ uniqueId }}"
    ng-style="{ marginTop: position[1], marginLeft: position[0] }"
    ng-transclude
  ></ul>
</div>
